import React from 'react';
import ProductPageTemplate from '../../components/ProductPageTemplate';
import { waterFillingMachines } from '../../mock/mockData';

const WaterFilling200BPM = () => {
  const productData = waterFillingMachines.find(p => p.id === 'wfm-200');
  return <ProductPageTemplate productData={productData} />;
};

export default WaterFilling200BPM;